// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("/src/assets/images/bg.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("/src/assets/images/HelixLogo.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body,
html {
  height: 100%;
  font-family: "Lato", sans-serif !important;
}

#root {
  display: block;
}

#loginForm input {
  height: 1.25em !important;
  line-height: 1em !important;
  font-size: 13px !important;
  border-radius: 3px !important;
  padding-left: 15px !important;
}

#loginForm .form-check-input:checked {
  background-color: #98cdfe;
  border-color: #98cdfe;
}

#loginForm .forgot-password-link {
  font-family: "Lato", sans-serif !important;
  font-size: 14px;
  cursor: pointer;
  color: #378ddc;
}

#loginForm .forgot-password-link:hover {
  text-decoration: underline;
}



/*-------- Preloader --------*/
.preloader {
  position: fixed;
  width: 100%;
  height: 100%;
  z-index: 999999999 !important;
  background-color: #fff;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}

.preloader .lds-ellipsis {
  display: inline-block;
  position: absolute;
  width: 80px;
  height: 80px;
  margin-top: -40px;
  margin-left: -40px;
  top: 50%;
  left: 50%;
}

.preloader .lds-ellipsis div {
  position: absolute;
  top: 33px;
  width: 13px;
  height: 13px;
  border-radius: 50%;
  background: #000;
  animation-timing-function: cubic-bezier(0, 1, 1, 0);
}

.preloader .lds-ellipsis div:nth-child(1) {
  left: 8px;
  animation: lds-ellipsis1 0.6s infinite;
}

.preloader .lds-ellipsis div:nth-child(2) {
  left: 8px;
  animation: lds-ellipsis2 0.6s infinite;
}

.preloader .lds-ellipsis div:nth-child(3) {
  left: 32px;
  animation: lds-ellipsis2 0.6s infinite;
}

.preloader .lds-ellipsis div:nth-child(4) {
  left: 56px;
  animation: lds-ellipsis3 0.6s infinite;
}

.preloader.preloader-dark {
  background-color: #000;
}

.preloader.preloader-dark .lds-ellipsis div {
  background-color: #fff;
}

@keyframes lds-ellipsis1 {
  0% {
    transform: scale(0);
  }

  100% {
    transform: scale(1);
  }
}

@keyframes lds-ellipsis3 {
  0% {
    transform: scale(1);
  }

  100% {
    transform: scale(0);
  }
}

@keyframes lds-ellipsis2 {
  0% {
    transform: translate(0, 0);
  }

  100% {
    transform: translate(24px, 0);
  }
}


img {
  vertical-align: inherit;
}

iframe {
  border: 0 !important;
}

/* =================================== */
/*  2. Helpers Classes
/* =================================== */
/* Box Shadow */
.oxyy-login-register .shadow-md {
  box-shadow: 0px 0px 50px -35px rgba(0, 0, 0, 0.4) !important;
}

/* Text Size */
.oxyy-login-register .text-0 {
  font-size: 11px !important;
  font-size: 0.6875rem !important;
}

.oxyy-login-register .text-1 {
  font-size: 12px !important;
  font-size: 0.75rem !important;
}

.oxyy-login-register .text-2 {
  font-size: 14px !important;
  font-size: 0.875rem !important;
}

.oxyy-login-register .text-3 {
  font-size: 16px !important;
  font-size: 1rem !important;
}

.oxyy-login-register .text-4 {
  font-size: 18px !important;
  font-size: 1.125rem !important;
}

.oxyy-login-register .text-5 {
  font-size: 21px !important;
  font-size: 1.3125rem !important;
}

.oxyy-login-register .text-6 {
  font-size: 24px !important;
  font-size: 1.50rem !important;
}

.oxyy-login-register .text-7 {
  font-size: 28px !important;
  font-size: 1.75rem !important;
}

.oxyy-login-register .text-8 {
  font-size: 32px !important;
  font-size: 2rem !important;
}

.oxyy-login-register .text-9 {
  font-size: 36px !important;
  font-size: 2.25rem !important;
}

.oxyy-login-register .text-10 {
  font-size: 40px !important;
  font-size: 2.50rem !important;
}

.oxyy-login-register .text-11 {
  font-size: calc(1.4rem + 1.8vw) !important;
}

@media (min-width: 1200px) {
  .oxyy-login-register .text-11 {
    font-size: 2.75rem !important;
  }
}

.oxyy-login-register .text-12 {
  font-size: calc(1.425rem + 2.1vw) !important;
}

@media (min-width: 1200px) {
  .oxyy-login-register .text-12 {
    font-size: 3rem !important;
  }
}

.oxyy-login-register .text-13 {
  font-size: calc(1.45rem + 2.4vw) !important;
}

@media (min-width: 1200px) {
  .oxyy-login-register .text-13 {
    font-size: 3.25rem !important;
  }
}

.oxyy-login-register .text-14 {
  font-size: calc(1.475rem + 2.7vw) !important;
}

@media (min-width: 1200px) {
  .oxyy-login-register .text-14 {
    font-size: 3.5rem !important;
  }
}

.oxyy-login-register .text-15 {
  font-size: calc(1.5rem + 3vw) !important;
}

@media (min-width: 1200px) {
  .oxyy-login-register .text-15 {
    font-size: 3.75rem !important;
  }
}

.oxyy-login-register .text-16 {
  font-size: calc(1.525rem + 3.3vw) !important;
}

@media (min-width: 1200px) {
  .oxyy-login-register .text-16 {
    font-size: 4rem !important;
  }
}

.oxyy-login-register .text-17 {
  font-size: calc(1.575rem + 3.9vw) !important;
}

@media (min-width: 1200px) {
  .oxyy-login-register .text-17 {
    font-size: 4.5rem !important;
  }
}

.oxyy-login-register .text-18 {
  font-size: calc(1.625rem + 4.5vw) !important;
}

@media (min-width: 1200px) {
  .oxyy-login-register .text-18 {
    font-size: 5rem !important;
  }
}

.oxyy-login-register .text-19 {
  font-size: calc(1.65rem + 4.8vw) !important;
}

@media (min-width: 1200px) {
  .oxyy-login-register .text-19 {
    font-size: 5.25rem !important;
  }
}

.oxyy-login-register .text-20 {
  font-size: calc(1.7rem + 5.4vw) !important;
}

@media (min-width: 1200px) {
  .oxyy-login-register .text-20 {
    font-size: 5.75rem !important;
  }
}

.oxyy-login-register .text-21 {
  font-size: calc(1.775rem + 6.3vw) !important;
}

@media (min-width: 1200px) {
  .oxyy-login-register .text-21 {
    font-size: 6.5rem !important;
  }
}

.oxyy-login-register .text-22 {
  font-size: calc(1.825rem + 6.9vw) !important;
}

@media (min-width: 1200px) {
  .oxyy-login-register .text-22 {
    font-size: 7rem !important;
  }
}

.oxyy-login-register .text-23 {
  font-size: calc(1.9rem + 7.8vw) !important;
}

@media (min-width: 1200px) {
  .oxyy-login-register .text-23 {
    font-size: 7.75rem !important;
  }
}

.oxyy-login-register .text-24 {
  font-size: calc(1.95rem + 8.4vw) !important;
}

@media (min-width: 1200px) {
  .oxyy-login-register .text-24 {
    font-size: 8.25rem !important;
  }
}

.oxyy-login-register .text-25 {
  font-size: calc(2.025rem + 9.3vw) !important;
}

@media (min-width: 1200px) {
  .oxyy-login-register .text-25 {
    font-size: 9rem !important;
  }
}

.oxyy-login-register .text-11,
.oxyy-login-register .text-12,
.oxyy-login-register .text-13,
.oxyy-login-register .text-14,
.oxyy-login-register .text-15,
.oxyy-login-register .text-16,
.oxyy-login-register .text-17,
.oxyy-login-register .text-18,
.oxyy-login-register .text-19,
.oxyy-login-register .text-20,
.oxyy-login-register .text-21,
.oxyy-login-register .text-22,
.oxyy-login-register .text-23,
.oxyy-login-register .text-24,
.oxyy-login-register .text-25 {
  line-height: 1.3;
}

/* Font Weight */
.oxyy-login-register .fw-100 {
  font-weight: 100 !important;
}

.oxyy-login-register .fw-200 {
  font-weight: 200 !important;
}

.oxyy-login-register .fw-300 {
  font-weight: 300 !important;
}

.oxyy-login-register .fw-400 {
  font-weight: 400 !important;
}

.oxyy-login-register .fw-500 {
  font-weight: 500 !important;
}

.oxyy-login-register .fw-600 {
  font-weight: 600 !important;
  font-size: 20px !important;
}

.oxyy-login-register .fw-700 {
  font-weight: 700 !important;
}

.oxyy-login-register .fw-800 {
  font-weight: 800 !important;
}

.oxyy-login-register .fw-900 {
  font-weight: 900 !important;
}

/* Opacity */
.oxyy-login-register .opacity-0 {
  opacity: 0;
}

.oxyy-login-register .opacity-1 {
  opacity: 0.1;
}

.oxyy-login-register .opacity-2 {
  opacity: 0.2;
}

.oxyy-login-register .opacity-3 {
  opacity: 0.3;
}

.oxyy-login-register .opacity-4 {
  opacity: 0.4;
}

.oxyy-login-register .opacity-5 {
  opacity: 0.5;
}

.oxyy-login-register .opacity-6 {
  opacity: 0.6;
}

.oxyy-login-register .opacity-7 {
  opacity: 0.7;
}

.oxyy-login-register .opacity-8 {
  opacity: 0.8;
}

.oxyy-login-register .opacity-9 {
  opacity: 0.9;
}

.oxyy-login-register .opacity-10 {
  opacity: 1;
}

/* Background light */
.oxyy-login-register .bg-light-1 {
  background-color: #e9ecef !important;
}

.oxyy-login-register .bg-light-2 {
  background-color: #dee2e6 !important;
}

.oxyy-login-register .bg-light-3 {
  background-color: #ced4da !important;
}

.oxyy-login-register .bg-light-4 {
  background-color: #adb5bd !important;
}

/* Background Dark */
.oxyy-login-register .bg-dark {
  background-color: #111418 !important;
}

.oxyy-login-register .bg-dark-1 {
  background-color: #212529 !important;
}

.oxyy-login-register .bg-dark-2 {
  background-color: #343a40 !important;
}

.oxyy-login-register .bg-dark-3 {
  background-color: #495057 !important;
}

.oxyy-login-register .bg-dark-4 {
  background-color: #6c757d !important;
}

.oxyy-login-register hr {
  opacity: 0.2;
}

/* =================================== */
/*  3. Layouts
/* =================================== */
.oxyy-login-register .section {
  position: relative;
  padding: 4.5rem 0;
  overflow: hidden;
}

@media (max-width: 575.98px) {
  .oxyy-login-register .section {
    padding: 3.5rem 0;
  }
}

@media (max-width: 575.98px) {
  .oxyy-login-register .modal .close {
    position: absolute;
    z-index: 1;
    right: 8px;
  }
}

/* =================================== */
/*  4. Elements
/* =================================== */
/*=== 4.1 Hero Background ===*/
.oxyy-login-register .hero-wrap {
  position: relative;
  overflow: hidden;
}

.oxyy-login-register .hero-wrap .hero-mask,
.oxyy-login-register .hero-wrap .hero-bg,
.oxyy-login-register .hero-wrap .hero-bg-slideshow {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
}

.oxyy-login-register .hero-wrap .hero-mask {
  z-index: 1;
}

.oxyy-login-register .hero-wrap .hero-content {
  position: relative;
  z-index: 2;
}

.oxyy-login-register .hero-wrap .hero-particles {
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 3;
}

.oxyy-login-register .hero-wrap .hero-bg-slideshow {
  z-index: 0;
}

.oxyy-login-register .hero-wrap .hero-bg {
  z-index: 0;
  background-attachment: fixed;
  background-position: center center;
  background-repeat: no-repeat;
  transition: background-image 300ms ease-in 200ms;
}

.oxyy-login-register .hero-wrap .hero-bg.hero-bg-scroll {
  background-attachment: scroll;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  width: 100% !important;
  opacity: 0.7;
}

.oxyy-login-register .hero-wrap .hero-bg-slideshow .hero-bg {
  background-attachment: inherit;
}

.oxyy-login-register .hero-wrap .hero-bg-slideshow.owl-carousel .owl-stage-outer,
.oxyy-login-register .hero-wrap .hero-bg-slideshow.owl-carousel .owl-stage,
.oxyy-login-register .hero-wrap .hero-bg-slideshow.owl-carousel .owl-item {
  height: 100%;
}

@media (max-width: 991.98px) {
  .oxyy-login-register .hero-wrap .hero-bg {
    background-attachment: initial !important;
    background-position: center center !important;
  }
}

/* 4.2 Nav */
.oxyy-login-register .nav .nav-item .nav-link {
  color: #495057;
}

.oxyy-login-register .nav:not(.nav-pills) .nav-item .nav-link.active,
.oxyy-login-register .nav:not(.nav-pills) .nav-item .nav-link:hover {
  color: var(--bs-themecolor);
}

.oxyy-login-register .nav.nav-separator .nav-item .nav-link {
  position: relative;
}

.oxyy-login-register .nav.nav-separator .nav-item+.nav-item .nav-link:after {
  height: 14px;
  width: 1px;
  content: ' ';
  background-color: rgba(0, 0, 0, 0.2);
  display: block;
  position: absolute;
  top: 50%;
  left: 0;
  transform: translateY(-7px);
}

.oxyy-login-register html[dir="rtl"] .nav.nav-separator .nav-item+.nav-item .nav-link:after {
  right: 0;
  left: auto;
}

.oxyy-login-register .nav.nav-separator.nav-separator-light .nav-item+.nav-item .nav-link:after {
  background-color: rgba(250, 250, 250, 0.2);
}

.oxyy-login-register .nav.nav-sm .nav-item .nav-link {
  font-size: 14px;
}

.oxyy-login-register .nav-pills .nav-link:not(.active):hover {
  color: var(--bs-themecolor);
}

.oxyy-login-register .nav-pills .nav-link.active,
.oxyy-login-register .nav-pills.nav-light .nav-link.active,
.oxyy-login-register .nav-pills .show>.nav-link {
  color: #fff;
}

.oxyy-login-register .nav-pills .nav-link {
  color: #7b8084;
}


.oxyy-login-register .nav-pills {
  --bs-nav-pills-link-active-bg: var(--bs-themecolor);
}

.oxyy-login-register [data-bs-theme="dark"] .nav .nav-item .nav-link:not(.active) {
  color: #dee2e6;
}

.oxyy-login-register [data-bs-theme="dark"] .nav:not(.nav-pills) .nav-item .nav-link.active,
.oxyy-login-register [data-bs-theme="dark"] .nav .nav-item .nav-link:not(.active):hover {
  color: var(--bs-themecolor);
}

.oxyy-login-register [data-bs-theme="dark"] .nav.nav-separator .nav-item+.nav-item .nav-link:after {
  background-color: rgba(250, 250, 250, 0.2);
}

/*=== 4.3 Tabs ===*/
.oxyy-login-register .nav-underline {
  --bs-nav-underline-gap: 0rem;
}

.oxyy-login-register .nav-underline .nav-link {
  padding-left: var(--bs-nav-link-padding-x);
  padding-right: var(--bs-nav-link-padding-x);
}

.oxyy-login-register .nav-underline .nav-link:not(.active):hover {
  border-bottom: 0px;
  border-bottom-color: transparent;
}

.oxyy-login-register .nav-underline .nav-link.active {
  font-weight: 500;
}

/* 4.4 Video Play button */
.oxyy-login-register .btn-video-play {
  width: 66px;
  height: 66px;
  line-height: 66px;
  text-align: center;
  display: inline-block;
  font-size: 16px;
  border-radius: 50%;
  background: #fff;
  box-shadow: 0px 0px 50px -35px rgba(0, 0, 0, 0.4);
  transition: all 0.8s ease-in-out;
}

.oxyy-login-register .btn-video-play:hover {
  box-shadow: 0px 0px 0px 8px rgba(250, 250, 250, 0.2);
}

/* =================================== */
/*  5. Social Icons
/* =================================== */
.oxyy-login-register .social-icons {
  margin: 0;
  padding: 0;
  display: flex;
  flex-wrap: wrap;
  list-style: none;
}

.oxyy-login-register .social-icons li {
  margin: 0px 6px 4px;
  padding: 0;
  overflow: visible;
}

.oxyy-login-register .social-icons li a {
  display: block;
  height: 38px;
  line-height: 38px;
  width: 38px;
  font-size: 18px;
  text-align: center;
  background-color: rgba(0, 0, 0, 0.6);
  color: #fff;
  text-decoration: none;
  transition: all 0.2s ease;
}

.oxyy-login-register .social-icons li i {
  line-height: inherit;
}

.oxyy-login-register .social-icons.social-icons-lg li a {
  height: 45px;
  line-height: 45px;
  width: 45px;
}

.oxyy-login-register .social-icons li:hover a {
  opacity: 0.8;
}

.oxyy-login-register .social-icons.social-icons-rounded li a {
  border-radius: .25rem;
}

.oxyy-login-register .social-icons.social-icons-circle li a {
  border-radius: 50%;
}

.oxyy-login-register .social-icons li.social-icons-twitter a {
  background-color: #00ACEE;
}

.oxyy-login-register .social-icons li.social-icons-facebook a {
  background-color: #1874eb;
}

.oxyy-login-register .social-icons li.social-icons-linkedin a {
  background-color: #0E76A8;
}

.oxyy-login-register .social-icons li.social-icons-google a {
  background-color: #DB4437;
}

.oxyy-login-register .social-icons li.social-icons-instagram a {
  background-color: #3F729B;
}

.oxyy-login-register .social-icons li.social-icons-vk a {
  background-color: #2B587A;
}

.oxyy-login-register .social-icons li.social-icons-yahoo a {
  background-color: #720E9E;
}

.oxyy-login-register .social-icons li.social-icons-apple a {
  background-color: #000;
}

.oxyy-login-register .social-icons li.social-icons-windows a {
  background-color: #0090f4;
}

.oxyy-login-register .social-icons li.social-icons-amazon a {
  background-color: #f79400;
}

.oxyy-login-register .btn-facebook {
  background-color: #1874eb;
  color: #fff !important;
}

.oxyy-login-register .btn-facebook:hover {
  background-color: #1266d2;
}

.oxyy-login-register .btn-outline-facebook {
  border-color: #1874eb;
  color: #1874eb;
}

.oxyy-login-register .btn-outline-facebook:hover {
  background-color: #1874eb;
  color: #fff;
}

.oxyy-login-register .btn-twitter {
  background-color: #00ACEE;
  color: #fff !important;
}

.oxyy-login-register .btn-twitter:hover {
  background-color: #0096cf;
}

.oxyy-login-register .btn-outline-twitter {
  border-color: #00ACEE;
  color: #00ACEE;
}

.oxyy-login-register .btn-outline-twitter:hover {
  background-color: #00ACEE;
  color: #fff;
}

.oxyy-login-register .btn-google {
  background-color: #DB4437;
  color: #fff !important;
}

.oxyy-login-register .btn-google:hover {
  background-color: #ce3325;
}

.oxyy-login-register .btn-outline-google {
  border-color: #DB4437;
  color: #DB4437;
}

.oxyy-login-register .btn-outline-google:hover {
  background-color: #DB4437;
  color: #fff;
}

.oxyy-login-register .btn-linkedin {
  background-color: #0E76A8;
  color: #fff !important;
}

.oxyy-login-register .btn-linkedin:hover {
  background-color: #0c628c;
}

.oxyy-login-register .btn-outline-linkedin {
  border-color: #0E76A8;
  color: #0E76A8;
}

.oxyy-login-register .btn-outline-linkedin:hover {
  background-color: #0E76A8;
  color: #fff;
}

.oxyy-login-register .btn-instagram {
  background-color: #3F729B;
  color: #fff !important;
}

.oxyy-login-register .btn-instagram:hover {
  background-color: #366285;
}

.oxyy-login-register .btn-outline-instagram {
  border-color: #3F729B;
  color: #3F729B;
}

.oxyy-login-register .btn-outline-instagram:hover {
  background-color: #3F729B;
  color: #fff;
}

.oxyy-login-register .btn-vk {
  background-color: #2B587A;
  color: #fff !important;
}

.oxyy-login-register .btn-vk:hover {
  background-color: #234863;
}

.oxyy-login-register .btn-outline-vk {
  border-color: #2B587A;
  color: #2B587A;
}

.oxyy-login-register .btn-outline-vk:hover {
  background-color: #2B587A;
  color: #fff;
}

.oxyy-login-register .btn-yahoo {
  background-color: #720E9E;
  color: #fff !important;
}

.oxyy-login-register .btn-yahoo:hover {
  background-color: #5e0c82;
}

.oxyy-login-register .btn-outline-yahoo {
  border-color: #720E9E;
  color: #720E9E;
}

.oxyy-login-register .btn-outline-yahoo:hover {
  background-color: #720E9E;
  color: #fff;
}

.oxyy-login-register .btn-apple {
  background-color: #000;
  color: #fff !important;
}

.oxyy-login-register .btn-apple:hover {
  background-color: black;
}

.oxyy-login-register .btn-outline-apple {
  border-color: #000;
  color: #000;
}

.oxyy-login-register .btn-outline-apple:hover {
  background-color: #000;
  color: #fff;
}

.oxyy-login-register .btn-windows {
  background-color: #0090f4;
  color: #fff !important;
}

.oxyy-login-register .btn-windows:hover {
  background-color: #007ed5;
}

.oxyy-login-register .btn-outline-windows {
  border-color: #0090f4;
  color: #0090f4;
}

.oxyy-login-register .btn-outline-windows:hover {
  background-color: #0090f4;
  color: #fff;
}

.oxyy-login-register .btn-amazon {
  background-color: #f79400;
  color: #fff !important;
}

.oxyy-login-register .btn-amazon:hover {
  background-color: #d88200;
}

.oxyy-login-register .btn-outline-amazon {
  border-color: #f79400;
  color: #f79400;
}

.oxyy-login-register .btn-outline-amazon:hover {
  background-color: #f79400;
  color: #fff;
}

/* =================================== */
/*  6. Extras
/* =================================== */
/* 6.1 Form */
.oxyy-login-register .form-control {
  border-color: #d1eaff;
  box-shadow: inset 0 0;
  background-color: #e8f1fb;
  border-radius: 4px !important;
}

.oxyy-login-register .form-check-input:not(:checked) {
  border-color: #dae1e3;
}

.oxyy-login-register .form-control.bg-light {
  background-color: #f5f5f6 !important;
}

.oxyy-login-register .form-control.border-light {
  border-color: #f5f5f6 !important;
}

.oxyy-login-register .form-control:not(.form-control-sm) {
  padding: 20px !important;
  height: inherit;
}

.oxyy-login-register .form-control-sm {
  font-size: 14px;
}

.oxyy-login-register .icon-group {
  position: relative;
}

.oxyy-login-register .icon-group .form-control {
  padding-left: 44px;
}

.oxyy-login-register .icon-group .icon-inside {
  position: absolute;
  width: 50px;
  height: 54px;
  left: 0;
  top: 0;
  pointer-events: none;
  font-size: 18px;
  font-size: 1.125rem;
  color: #c4c3c3;
  z-index: 3;
  display: flex;
  align-items: center !important;
  justify-content: center !important;
}

.oxyy-login-register .icon-group.icon-group-end .form-control {
  padding-right: 44px;
  padding-left: 0.96rem;
}

.oxyy-login-register .icon-group.icon-group-end .icon-inside {
  left: auto;
  right: 0;
}

.oxyy-login-register .form-control-sm+.icon-inside {
  font-size: 0.875rem !important;
  font-size: 14px;
  top: calc(50% - 13px);
}

.oxyy-login-register select.form-control:not([size]):not([multiple]):not(.form-control-sm) {
  height: auto;
  padding-top: .700rem;
  padding-bottom: .700rem;
}

.oxyy-login-register .form-control:focus {
  box-shadow: 0 0 5px rgba(128, 189, 255, 0.5);
  border-color: #80bdff !important;
}

.oxyy-login-register .form-control:focus[readonly] {
  box-shadow: none;
}

.oxyy-login-register .input-group-text {
  border-color: #dae1e3;
  background-color: #f1f5f6;
  color: #656565;
}

.oxyy-login-register .form-control::-webkit-input-placeholder {
  color: #b1b4b6;
}

.oxyy-login-register .form-control:-moz-placeholder {
  /* FF 4-18 */
  color: #b1b4b6;
}

.oxyy-login-register .form-control::-moz-placeholder {
  /* FF 19+ */
  color: #b1b4b6;
}

.oxyy-login-register .form-control:-ms-input-placeholder,
.oxyy-login-register .form-control::-ms-input-placeholder {
  /* IE 10+ */
  color: #b1b4b6;
}

/* 6.2 Form Dark */
.oxyy-login-register .form-dark .form-control {
  border-color: #232a31;
  background: #232a31;
  color: #fff;
}

.oxyy-login-register .form-dark .form-control:focus {
  border-color: #80bdff !important;
}

.oxyy-login-register .form-dark .form-control::-webkit-input-placeholder {
  color: #777b7f;
}

.oxyy-login-register .form-dark .form-control:-moz-placeholder {
  /* FF 4-18 */
  color: #777b7f;
}

.oxyy-login-register .form-dark .form-control::-moz-placeholder {
  /* FF 19+ */
  color: #777b7f;
}

.oxyy-login-register .form-dark .form-control:-ms-input-placeholder,
.oxyy-login-register .form-dark .form-control::-ms-input-placeholder {
  /* IE 10+ */
  color: #777b7f;
}

.oxyy-login-register .form-dark .icon-group .icon-inside {
  color: #777b7f;
}

.oxyy-login-register .form-dark .form-check-input:not(:checked) {
  background-color: #232a31;
  border-color: #232a31;
}

/* 6.3 Form Border (Input with only bottom border)  */
.oxyy-login-register .form-border .form-control {
  background-color: transparent;
  border: none;
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);
  border-radius: 0px;
  padding-left: 0px !important;
  color: black;
}

.oxyy-login-register .form-border .form-control::-webkit-input-placeholder {
  color: rgba(0, 0, 0, 0.4);
}

.oxyy-login-register .form-border .form-control:-moz-placeholder {
  /* FF 4-18 */
  color: rgba(0, 0, 0, 0.4);
}

.oxyy-login-register .form-border .form-control::-moz-placeholder {
  /* FF 19+ */
  color: rgba(0, 0, 0, 0.4);
}

.oxyy-login-register .form-border .form-control:-ms-input-placeholder,
.oxyy-login-register .form-border .form-control::-ms-input-placeholder {
  /* IE 10+ */
  color: rgba(0, 0, 0, 0.4);
}

.oxyy-login-register .form-border .form-control:focus {
  box-shadow: none;
  -webkit-box-shadow: none;
  border-bottom-color: rgba(0, 0, 0, 0.7);
}

.oxyy-login-register .form-border .form-control:focus.border-dark {
  border-color: var(--bs-themecolor) !important;
}

.oxyy-login-register .form-border .form-control:not(output):-moz-ui-invalid:not(:focus),
.oxyy-login-register .form-border .form-control:not(output):-moz-ui-invalid:-moz-focusring:not(:focus) {
  border-bottom-color: #e10203;
  box-shadow: none;
  -webkit-box-shadow: none;
}

.oxyy-login-register .form-border .form-control:not(output):-moz-ui-invalid:not(:focus).border-dark,
.oxyy-login-register .form-border .form-control:not(output):-moz-ui-invalid:-moz-focusring:not(:focus).border-dark {
  border-color: #e10203 !important;
}

.oxyy-login-register .form-border select option {
  color: #666;
}

.oxyy-login-register .form-border .icon-group .form-control {
  padding-left: 30px !important;
}

.oxyy-login-register .form-border .icon-group .icon-inside {
  color: rgba(0, 0, 0, 0.25);
  width: 30px;
  height: 52px;
  display: flex;
  align-items: center !important;
  justify-content: flex-start !important;
}

.oxyy-login-register .form-border .icon-group.icon-group-end .form-control {
  padding-right: 30px !important;
  padding-left: 0 !important;
}

.oxyy-login-register .form-border .icon-group.icon-group-end .icon-inside {
  left: auto;
  right: 0;
  justify-content: flex-end !important;
}

/* 6.4 Form Border Light (Input with only bottom border)  */
.oxyy-login-register .form-border-light .form-control {
  border-bottom: 1px solid rgba(250, 250, 250, 0.3);
  color: #fafafa;
}

.oxyy-login-register .form-border-light .form-control::-webkit-input-placeholder {
  color: rgba(250, 250, 250, 0.7);
}

.oxyy-login-register .form-border-light .form-control:-moz-placeholder {
  /* FF 4-18 */
  color: rgba(250, 250, 250, 0.7);
}

.oxyy-login-register .form-border-light .form-control::-moz-placeholder {
  /* FF 19+ */
  color: rgba(250, 250, 250, 0.7);
}

.oxyy-login-register .form-border-light .form-control:-ms-input-placeholder,
.oxyy-login-register .form-border-light .form-control::-ms-input-placeholder {
  /* IE 10+ */
  color: rgba(250, 250, 250, 0.7);
}

.oxyy-login-register .form-border-light .form-control:focus {
  border-bottom-color: rgba(250, 250, 250, 0.8);
}

.oxyy-login-register .form-border-light .form-control:focus.border-light {
  border-color: var(--bs-themecolor) !important;
}

.oxyy-login-register .form-border-light .icon-group .icon-inside {
  color: #777b7f;
}

.oxyy-login-register .form-border-light select option {
  color: #333;
}

/* 6.5 Vertical Multilple input group */
.oxyy-login-register .vertical-input-group .input-group:first-child {
  padding-bottom: 0;
}

.oxyy-login-register .vertical-input-group .input-group:first-child * {
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}

.oxyy-login-register .vertical-input-group .input-group:last-child {
  padding-top: 0;
}

.oxyy-login-register .vertical-input-group .input-group:last-child * {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

.oxyy-login-register .vertical-input-group .input-group:not(:last-child):not(:first-child) {
  padding-top: 0;
  padding-bottom: 0;
}

.oxyy-login-register .vertical-input-group .input-group:not(:last-child):not(:first-child) * {
  border-radius: 0;
}

.oxyy-login-register .vertical-input-group .input-group:not(:first-child) * {
  border-top: 0;
}

/* 6.6 Other Bootstrap Specific */
.oxyy-login-register .btn {
  padding: 0.8rem 2.6rem;
  font-weight: 500;
  transition: all 0.5s ease;
}

.oxyy-login-register .btn-sm {
  padding: 0.5rem 1rem;
}

.oxyy-login-register .btn:not(.btn-link) {
  box-shadow: 0px 5px 15px rgba(0, 0, 0, 0.15);
}

.oxyy-login-register .btn:not(.btn-link):hover {
  box-shadow: 0px 5px 15px rgba(0, 0, 0, 0.3);
  transition: all 0.5s ease;
}

.oxyy-login-register .input-group-append .btn,
.oxyy-login-register .input-group-prepend .btn {
  box-shadow: none;
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}

.oxyy-login-register .input-group-append .btn:hover,
.oxyy-login-register .input-group-prepend .btn:hover {
  box-shadow: none;
}

@media (max-width: 575.98px) {
  .oxyy-login-register .btn:not(.btn-sm) {
    padding: .810rem 2rem;
  }

  .oxyy-login-register .input-group>.input-group-append>.btn,
  .oxyy-login-register .input-group>.input-group-prepend>.btn {
    padding: 0 0.75rem;
  }
}

.oxyy-login-register .btn-primary {
  background-color: #1170e6;
  font-size: 16px;
}

.oxyy-login-register .btn-outline-primary {
  --bs-btn-color: var(--bs-themecolor);
  --bs-btn-border-color: var(--bs-themecolor);
  --bs-btn-hover-bg: var(--bs-themecolor);
  --bs-btn-hover-color: var(--bs-white);
  --bs-btn-hover-border-color: var(--bs-themecolor);
  --bs-btn-active-color: var(--bs-btn-hover-color);
  --bs-btn-active-bg: var(--bs-themehovercolor);
  --bs-btn-active-border-color: var(--bs-themehovercolor);
}

.oxyy-login-register .progress,
.oxyy-login-register .progress-stacked {
  --bs-progress-bar-bg: var(--bs-themecolor);
}

.oxyy-login-register .pagination {
  --bs-pagination-active-bg: var(--bs-themecolor);
  --bs-pagination-active-border-color: var(--bs-themecolor);
}

/* styles-switcher */
#styles-switcher {
  background: #fff;
  width: 202px;
  position: fixed;
  top: 35%;
  z-index: 1051;
  padding: 20px;
  left: -202px;
}

#styles-switcher ul {
  padding: 0;
}

#styles-switcher ul li {
  list-style-type: none;
  width: 24px;
  height: 24px;
  line-height: 24px;
  margin: 4px 2px;
  border-radius: 50%;
  display: inline-block;
  cursor: pointer;
  text-align: center;
  color: #fff;
  transition: all .2s ease-in-out;
}

#styles-switcher ul li.blue {
  background: #007bff;
}

#styles-switcher ul li.brown {
  background: #795548;
}

#styles-switcher ul li.purple {
  background: #6f42c1;
}

#styles-switcher ul li.indigo {
  background: #6610f2;
}

#styles-switcher ul li.red {
  background: #dc3545;
}

#styles-switcher ul li.orange {
  background: #fd7e14;
}

#styles-switcher ul li.yellow {
  background: #ffc107;
}

#styles-switcher ul li.green {
  background: #28a745;
}

#styles-switcher ul li.teal {
  background: #20c997;
}

#styles-switcher ul li.pink {
  background: #e83e8c;
}

#styles-switcher ul li.cyan {
  background: #17a2b8;
}

#styles-switcher ul li.active {
  transform: scale(0.7);
  cursor: default;
}

#styles-switcher .switcher-toggle {
  position: absolute;
  background: #555;
  color: #fff;
  font-size: 1.25rem;
  border-radius: 0px 4px 4px 0;
  right: -40px;
  top: 0;
  width: 40px;
  height: 40px;
  padding: 0;
}

#styles-switcher .switcher-toggle:focus {
  box-shadow: none;
}

#styles-switcher #reset-color {
  background: #007bff;
}

input:-internal-autofill-selected {
  background-color: transparent;
}

#styles-switcher.right {
  left: auto;
  right: -202px;
}

#styles-switcher.right .switcher-toggle {
  right: auto;
  left: -40px;
  border-radius: 4px 0px 0px 4px;
}

.hero-bg .hero-bg-scroll {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) !important;
}

.btn:first-child:active {
  background-color: #0257d5;
  color: #fff;
}

#logo {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) !important;
}

.fn {
  font-size: 14px;
  color: #004397;
}
`, "",{"version":3,"sources":["webpack://./src/app/pages/auth-pages/login/Login.css"],"names":[],"mappings":"AAAA;;EAEE,YAAY;EACZ,0CAA0C;AAC5C;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,0BAA0B;EAC1B,6BAA6B;EAC7B,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,0CAA0C;EAC1C,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,0BAA0B;AAC5B;;;;AAIA,8BAA8B;AAC9B;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,6BAA6B;EAC7B,sBAAsB;EACtB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,mDAAmD;AACrD;;AAEA;EACE,SAAS;EACT,sCAAsC;AACxC;;AAEA;EACE,SAAS;EACT,sCAAsC;AACxC;;AAEA;EACE,UAAU;EACV,sCAAsC;AACxC;;AAEA;EACE,UAAU;EACV,sCAAsC;AACxC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,6BAA6B;EAC/B;AACF;;;AAGA;EACE,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;AACtB;;AAEA,wCAAwC;AACxC;wCACwC;AACxC,eAAe;AACf;EAEE,4DAA4D;AAC9D;;AAEA,cAAc;AACd;EACE,0BAA0B;EAC1B,+BAA+B;AACjC;;AAEA;EACE,0BAA0B;EAC1B,6BAA6B;AAC/B;;AAEA;EACE,0BAA0B;EAC1B,8BAA8B;AAChC;;AAEA;EACE,0BAA0B;EAC1B,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;EAC1B,8BAA8B;AAChC;;AAEA;EACE,0BAA0B;EAC1B,+BAA+B;AACjC;;AAEA;EACE,0BAA0B;EAC1B,6BAA6B;AAC/B;;AAEA;EACE,0BAA0B;EAC1B,6BAA6B;AAC/B;;AAEA;EACE,0BAA0B;EAC1B,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;EAC1B,6BAA6B;AAC/B;;AAEA;EACE,0BAA0B;EAC1B,6BAA6B;AAC/B;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE;IACE,6BAA6B;EAC/B;AACF;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE;IACE,6BAA6B;EAC/B;AACF;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE;IACE,4BAA4B;EAC9B;AACF;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE;IACE,6BAA6B;EAC/B;AACF;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE;IACE,4BAA4B;EAC9B;AACF;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE;IACE,6BAA6B;EAC/B;AACF;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE;IACE,6BAA6B;EAC/B;AACF;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE;IACE,4BAA4B;EAC9B;AACF;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE;IACE,6BAA6B;EAC/B;AACF;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE;IACE,6BAA6B;EAC/B;AACF;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;;;;;;;;;;;;;;;EAeE,gBAAgB;AAClB;;AAEA,gBAAgB;AAChB;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;EAC3B,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA,YAAY;AACZ;EACE,UAAU;AACZ;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;;AAEA,qBAAqB;AACrB;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA,oBAAoB;AACpB;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,YAAY;AACd;;AAEA,wCAAwC;AACxC;wCACwC;AACxC;EACE,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,kBAAkB;IAClB,UAAU;IACV,UAAU;EACZ;AACF;;AAEA,wCAAwC;AACxC;wCACwC;AACxC,8BAA8B;AAC9B;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;;;EAGE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,4BAA4B;EAC5B,kCAAkC;EAClC,4BAA4B;EAC5B,gDAAgD;AAClD;;AAEA;EACE,6BAA6B;EAC7B,yDAAgD;EAChD,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,8BAA8B;AAChC;;AAEA;;;EAGE,YAAY;AACd;;AAEA;EACE;IACE,yCAAyC;IACzC,6CAA6C;EAC/C;AACF;;AAEA,YAAY;AACZ;EACE,cAAc;AAChB;;AAEA;;EAEE,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,YAAY;EACZ,oCAAoC;EACpC,cAAc;EACd,kBAAkB;EAClB,QAAQ;EACR,OAAO;EAEP,2BAA2B;AAC7B;;AAEA;EACE,QAAQ;EACR,UAAU;AACZ;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;;;EAGE,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;;AAGA;EACE,mDAAmD;AACrD;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,2BAA2B;AAC7B;;AAEA;EACE,0CAA0C;AAC5C;;AAEA,mBAAmB;AACnB;EACE,4BAA4B;AAC9B;;AAEA;EACE,0CAA0C;EAC1C,2CAA2C;AAC7C;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;AAClB;;AAEA,0BAA0B;AAC1B;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,qBAAqB;EACrB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAEhB,iDAAiD;EAEjD,gCAAgC;AAClC;;AAEA;EAEE,oDAAoD;AACtD;;AAEA,wCAAwC;AACxC;wCACwC;AACxC;EACE,SAAS;EACT,UAAU;EAEV,aAAa;EAEb,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,UAAU;EACV,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,iBAAiB;EACjB,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,oCAAoC;EACpC,WAAW;EACX,qBAAqB;EAErB,yBAAyB;AAC3B;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA,wCAAwC;AACxC;wCACwC;AACxC,aAAa;AACb;EACE,qBAAqB;EACrB,qBAAqB;EACrB,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,wBAAwB;EACxB,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,OAAO;EACP,MAAM;EACN,oBAAoB;EACpB,eAAe;EACf,mBAAmB;EACnB,cAAc;EACd,UAAU;EACV,aAAa;EAEb,8BAA8B;EAE9B,kCAAkC;AACpC;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,UAAU;EACV,QAAQ;AACV;;AAEA;EACE,8BAA8B;EAC9B,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,oBAAoB;EACpB,uBAAuB;AACzB;;AAEA;EAEE,4CAA4C;EAC5C,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,cAAc;AAChB;;AAEA;;EAEE,WAAW;EACX,cAAc;AAChB;;AAEA,kBAAkB;AAClB;EACE,qBAAqB;EACrB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,cAAc;AAChB;;AAEA;;EAEE,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA,qDAAqD;AACrD;EACE,6BAA6B;EAC7B,YAAY;EACZ,4CAA4C;EAC5C,kBAAkB;EAClB,4BAA4B;EAC5B,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;;EAEE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;EACxB,uCAAuC;AACzC;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;;EAEE,4BAA4B;EAC5B,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;;EAEE,gCAAgC;AAClC;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,0BAA0B;EAC1B,WAAW;EACX,YAAY;EACZ,aAAa;EAEb,8BAA8B;EAE9B,sCAAsC;AACxC;;AAEA;EACE,8BAA8B;EAC9B,0BAA0B;AAC5B;;AAEA;EACE,UAAU;EACV,QAAQ;EAER,oCAAoC;AACtC;;AAEA,2DAA2D;AAC3D;EACE,iDAAiD;EACjD,cAAc;AAChB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,YAAY;EACZ,+BAA+B;AACjC;;AAEA;EACE,WAAW;EACX,+BAA+B;AACjC;;AAEA;;EAEE,WAAW;EACX,+BAA+B;AACjC;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA,uCAAuC;AACvC;EACE,iBAAiB;AACnB;;AAEA;EACE,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA,iCAAiC;AACjC;EACE,sBAAsB;EACtB,gBAAgB;EAEhB,yBAAyB;AAC3B;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EAEE,4CAA4C;AAC9C;;AAEA;EAEE,2CAA2C;EAE3C,yBAAyB;AAC3B;;AAEA;;EAGE,gBAAgB;EAChB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;;EAGE,gBAAgB;AAClB;;AAEA;EACE;IACE,qBAAqB;EACvB;;EAEA;;IAEE,kBAAkB;EACpB;AACF;;AAEA;EACE,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,oCAAoC;EACpC,2CAA2C;EAC3C,uCAAuC;EACvC,qCAAqC;EACrC,iDAAiD;EACjD,gDAAgD;EAChD,6CAA6C;EAC7C,uDAAuD;AACzD;;AAEA;;EAEE,0CAA0C;AAC5C;;AAEA;EACE,+CAA+C;EAC/C,yDAAyD;AAC3D;;AAEA,oBAAoB;AACpB;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,QAAQ;EACR,aAAa;EACb,aAAa;EACb,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,qBAAqB;EACrB,eAAe;EACf,kBAAkB;EAClB,WAAW;EACX,+BAA+B;AACjC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,4BAA4B;EAC5B,YAAY;EACZ,MAAM;EACN,WAAW;EACX,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,UAAU;EACV,aAAa;AACf;;AAEA;EACE,WAAW;EACX,WAAW;EACX,8BAA8B;AAChC;;AAEA;EACE,oEAA6D;AAC/D;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,oEAAoE;AACtE;;AAEA;EACE,eAAe;EACf,cAAc;AAChB","sourcesContent":["body,\nhtml {\n  height: 100%;\n  font-family: \"Lato\", sans-serif !important;\n}\n\n#root {\n  display: block;\n}\n\n#loginForm input {\n  height: 1.25em !important;\n  line-height: 1em !important;\n  font-size: 13px !important;\n  border-radius: 3px !important;\n  padding-left: 15px !important;\n}\n\n#loginForm .form-check-input:checked {\n  background-color: #98cdfe;\n  border-color: #98cdfe;\n}\n\n#loginForm .forgot-password-link {\n  font-family: \"Lato\", sans-serif !important;\n  font-size: 14px;\n  cursor: pointer;\n  color: #378ddc;\n}\n\n#loginForm .forgot-password-link:hover {\n  text-decoration: underline;\n}\n\n\n\n/*-------- Preloader --------*/\n.preloader {\n  position: fixed;\n  width: 100%;\n  height: 100%;\n  z-index: 999999999 !important;\n  background-color: #fff;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n}\n\n.preloader .lds-ellipsis {\n  display: inline-block;\n  position: absolute;\n  width: 80px;\n  height: 80px;\n  margin-top: -40px;\n  margin-left: -40px;\n  top: 50%;\n  left: 50%;\n}\n\n.preloader .lds-ellipsis div {\n  position: absolute;\n  top: 33px;\n  width: 13px;\n  height: 13px;\n  border-radius: 50%;\n  background: #000;\n  animation-timing-function: cubic-bezier(0, 1, 1, 0);\n}\n\n.preloader .lds-ellipsis div:nth-child(1) {\n  left: 8px;\n  animation: lds-ellipsis1 0.6s infinite;\n}\n\n.preloader .lds-ellipsis div:nth-child(2) {\n  left: 8px;\n  animation: lds-ellipsis2 0.6s infinite;\n}\n\n.preloader .lds-ellipsis div:nth-child(3) {\n  left: 32px;\n  animation: lds-ellipsis2 0.6s infinite;\n}\n\n.preloader .lds-ellipsis div:nth-child(4) {\n  left: 56px;\n  animation: lds-ellipsis3 0.6s infinite;\n}\n\n.preloader.preloader-dark {\n  background-color: #000;\n}\n\n.preloader.preloader-dark .lds-ellipsis div {\n  background-color: #fff;\n}\n\n@keyframes lds-ellipsis1 {\n  0% {\n    transform: scale(0);\n  }\n\n  100% {\n    transform: scale(1);\n  }\n}\n\n@keyframes lds-ellipsis3 {\n  0% {\n    transform: scale(1);\n  }\n\n  100% {\n    transform: scale(0);\n  }\n}\n\n@keyframes lds-ellipsis2 {\n  0% {\n    transform: translate(0, 0);\n  }\n\n  100% {\n    transform: translate(24px, 0);\n  }\n}\n\n\nimg {\n  vertical-align: inherit;\n}\n\niframe {\n  border: 0 !important;\n}\n\n/* =================================== */\n/*  2. Helpers Classes\n/* =================================== */\n/* Box Shadow */\n.oxyy-login-register .shadow-md {\n  -webkit-box-shadow: 0px 0px 50px -35px rgba(0, 0, 0, 0.4) !important;\n  box-shadow: 0px 0px 50px -35px rgba(0, 0, 0, 0.4) !important;\n}\n\n/* Text Size */\n.oxyy-login-register .text-0 {\n  font-size: 11px !important;\n  font-size: 0.6875rem !important;\n}\n\n.oxyy-login-register .text-1 {\n  font-size: 12px !important;\n  font-size: 0.75rem !important;\n}\n\n.oxyy-login-register .text-2 {\n  font-size: 14px !important;\n  font-size: 0.875rem !important;\n}\n\n.oxyy-login-register .text-3 {\n  font-size: 16px !important;\n  font-size: 1rem !important;\n}\n\n.oxyy-login-register .text-4 {\n  font-size: 18px !important;\n  font-size: 1.125rem !important;\n}\n\n.oxyy-login-register .text-5 {\n  font-size: 21px !important;\n  font-size: 1.3125rem !important;\n}\n\n.oxyy-login-register .text-6 {\n  font-size: 24px !important;\n  font-size: 1.50rem !important;\n}\n\n.oxyy-login-register .text-7 {\n  font-size: 28px !important;\n  font-size: 1.75rem !important;\n}\n\n.oxyy-login-register .text-8 {\n  font-size: 32px !important;\n  font-size: 2rem !important;\n}\n\n.oxyy-login-register .text-9 {\n  font-size: 36px !important;\n  font-size: 2.25rem !important;\n}\n\n.oxyy-login-register .text-10 {\n  font-size: 40px !important;\n  font-size: 2.50rem !important;\n}\n\n.oxyy-login-register .text-11 {\n  font-size: calc(1.4rem + 1.8vw) !important;\n}\n\n@media (min-width: 1200px) {\n  .oxyy-login-register .text-11 {\n    font-size: 2.75rem !important;\n  }\n}\n\n.oxyy-login-register .text-12 {\n  font-size: calc(1.425rem + 2.1vw) !important;\n}\n\n@media (min-width: 1200px) {\n  .oxyy-login-register .text-12 {\n    font-size: 3rem !important;\n  }\n}\n\n.oxyy-login-register .text-13 {\n  font-size: calc(1.45rem + 2.4vw) !important;\n}\n\n@media (min-width: 1200px) {\n  .oxyy-login-register .text-13 {\n    font-size: 3.25rem !important;\n  }\n}\n\n.oxyy-login-register .text-14 {\n  font-size: calc(1.475rem + 2.7vw) !important;\n}\n\n@media (min-width: 1200px) {\n  .oxyy-login-register .text-14 {\n    font-size: 3.5rem !important;\n  }\n}\n\n.oxyy-login-register .text-15 {\n  font-size: calc(1.5rem + 3vw) !important;\n}\n\n@media (min-width: 1200px) {\n  .oxyy-login-register .text-15 {\n    font-size: 3.75rem !important;\n  }\n}\n\n.oxyy-login-register .text-16 {\n  font-size: calc(1.525rem + 3.3vw) !important;\n}\n\n@media (min-width: 1200px) {\n  .oxyy-login-register .text-16 {\n    font-size: 4rem !important;\n  }\n}\n\n.oxyy-login-register .text-17 {\n  font-size: calc(1.575rem + 3.9vw) !important;\n}\n\n@media (min-width: 1200px) {\n  .oxyy-login-register .text-17 {\n    font-size: 4.5rem !important;\n  }\n}\n\n.oxyy-login-register .text-18 {\n  font-size: calc(1.625rem + 4.5vw) !important;\n}\n\n@media (min-width: 1200px) {\n  .oxyy-login-register .text-18 {\n    font-size: 5rem !important;\n  }\n}\n\n.oxyy-login-register .text-19 {\n  font-size: calc(1.65rem + 4.8vw) !important;\n}\n\n@media (min-width: 1200px) {\n  .oxyy-login-register .text-19 {\n    font-size: 5.25rem !important;\n  }\n}\n\n.oxyy-login-register .text-20 {\n  font-size: calc(1.7rem + 5.4vw) !important;\n}\n\n@media (min-width: 1200px) {\n  .oxyy-login-register .text-20 {\n    font-size: 5.75rem !important;\n  }\n}\n\n.oxyy-login-register .text-21 {\n  font-size: calc(1.775rem + 6.3vw) !important;\n}\n\n@media (min-width: 1200px) {\n  .oxyy-login-register .text-21 {\n    font-size: 6.5rem !important;\n  }\n}\n\n.oxyy-login-register .text-22 {\n  font-size: calc(1.825rem + 6.9vw) !important;\n}\n\n@media (min-width: 1200px) {\n  .oxyy-login-register .text-22 {\n    font-size: 7rem !important;\n  }\n}\n\n.oxyy-login-register .text-23 {\n  font-size: calc(1.9rem + 7.8vw) !important;\n}\n\n@media (min-width: 1200px) {\n  .oxyy-login-register .text-23 {\n    font-size: 7.75rem !important;\n  }\n}\n\n.oxyy-login-register .text-24 {\n  font-size: calc(1.95rem + 8.4vw) !important;\n}\n\n@media (min-width: 1200px) {\n  .oxyy-login-register .text-24 {\n    font-size: 8.25rem !important;\n  }\n}\n\n.oxyy-login-register .text-25 {\n  font-size: calc(2.025rem + 9.3vw) !important;\n}\n\n@media (min-width: 1200px) {\n  .oxyy-login-register .text-25 {\n    font-size: 9rem !important;\n  }\n}\n\n.oxyy-login-register .text-11,\n.oxyy-login-register .text-12,\n.oxyy-login-register .text-13,\n.oxyy-login-register .text-14,\n.oxyy-login-register .text-15,\n.oxyy-login-register .text-16,\n.oxyy-login-register .text-17,\n.oxyy-login-register .text-18,\n.oxyy-login-register .text-19,\n.oxyy-login-register .text-20,\n.oxyy-login-register .text-21,\n.oxyy-login-register .text-22,\n.oxyy-login-register .text-23,\n.oxyy-login-register .text-24,\n.oxyy-login-register .text-25 {\n  line-height: 1.3;\n}\n\n/* Font Weight */\n.oxyy-login-register .fw-100 {\n  font-weight: 100 !important;\n}\n\n.oxyy-login-register .fw-200 {\n  font-weight: 200 !important;\n}\n\n.oxyy-login-register .fw-300 {\n  font-weight: 300 !important;\n}\n\n.oxyy-login-register .fw-400 {\n  font-weight: 400 !important;\n}\n\n.oxyy-login-register .fw-500 {\n  font-weight: 500 !important;\n}\n\n.oxyy-login-register .fw-600 {\n  font-weight: 600 !important;\n  font-size: 20px !important;\n}\n\n.oxyy-login-register .fw-700 {\n  font-weight: 700 !important;\n}\n\n.oxyy-login-register .fw-800 {\n  font-weight: 800 !important;\n}\n\n.oxyy-login-register .fw-900 {\n  font-weight: 900 !important;\n}\n\n/* Opacity */\n.oxyy-login-register .opacity-0 {\n  opacity: 0;\n}\n\n.oxyy-login-register .opacity-1 {\n  opacity: 0.1;\n}\n\n.oxyy-login-register .opacity-2 {\n  opacity: 0.2;\n}\n\n.oxyy-login-register .opacity-3 {\n  opacity: 0.3;\n}\n\n.oxyy-login-register .opacity-4 {\n  opacity: 0.4;\n}\n\n.oxyy-login-register .opacity-5 {\n  opacity: 0.5;\n}\n\n.oxyy-login-register .opacity-6 {\n  opacity: 0.6;\n}\n\n.oxyy-login-register .opacity-7 {\n  opacity: 0.7;\n}\n\n.oxyy-login-register .opacity-8 {\n  opacity: 0.8;\n}\n\n.oxyy-login-register .opacity-9 {\n  opacity: 0.9;\n}\n\n.oxyy-login-register .opacity-10 {\n  opacity: 1;\n}\n\n/* Background light */\n.oxyy-login-register .bg-light-1 {\n  background-color: #e9ecef !important;\n}\n\n.oxyy-login-register .bg-light-2 {\n  background-color: #dee2e6 !important;\n}\n\n.oxyy-login-register .bg-light-3 {\n  background-color: #ced4da !important;\n}\n\n.oxyy-login-register .bg-light-4 {\n  background-color: #adb5bd !important;\n}\n\n/* Background Dark */\n.oxyy-login-register .bg-dark {\n  background-color: #111418 !important;\n}\n\n.oxyy-login-register .bg-dark-1 {\n  background-color: #212529 !important;\n}\n\n.oxyy-login-register .bg-dark-2 {\n  background-color: #343a40 !important;\n}\n\n.oxyy-login-register .bg-dark-3 {\n  background-color: #495057 !important;\n}\n\n.oxyy-login-register .bg-dark-4 {\n  background-color: #6c757d !important;\n}\n\n.oxyy-login-register hr {\n  opacity: 0.2;\n}\n\n/* =================================== */\n/*  3. Layouts\n/* =================================== */\n.oxyy-login-register .section {\n  position: relative;\n  padding: 4.5rem 0;\n  overflow: hidden;\n}\n\n@media (max-width: 575.98px) {\n  .oxyy-login-register .section {\n    padding: 3.5rem 0;\n  }\n}\n\n@media (max-width: 575.98px) {\n  .oxyy-login-register .modal .close {\n    position: absolute;\n    z-index: 1;\n    right: 8px;\n  }\n}\n\n/* =================================== */\n/*  4. Elements\n/* =================================== */\n/*=== 4.1 Hero Background ===*/\n.oxyy-login-register .hero-wrap {\n  position: relative;\n  overflow: hidden;\n}\n\n.oxyy-login-register .hero-wrap .hero-mask,\n.oxyy-login-register .hero-wrap .hero-bg,\n.oxyy-login-register .hero-wrap .hero-bg-slideshow {\n  position: absolute;\n  top: 0;\n  left: 0;\n  height: 100%;\n  width: 100%;\n}\n\n.oxyy-login-register .hero-wrap .hero-mask {\n  z-index: 1;\n}\n\n.oxyy-login-register .hero-wrap .hero-content {\n  position: relative;\n  z-index: 2;\n}\n\n.oxyy-login-register .hero-wrap .hero-particles {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  z-index: 3;\n}\n\n.oxyy-login-register .hero-wrap .hero-bg-slideshow {\n  z-index: 0;\n}\n\n.oxyy-login-register .hero-wrap .hero-bg {\n  z-index: 0;\n  background-attachment: fixed;\n  background-position: center center;\n  background-repeat: no-repeat;\n  transition: background-image 300ms ease-in 200ms;\n}\n\n.oxyy-login-register .hero-wrap .hero-bg.hero-bg-scroll {\n  background-attachment: scroll;\n  background-image: url(/src/assets/images/bg.png);\n  width: 100% !important;\n  opacity: 0.7;\n}\n\n.oxyy-login-register .hero-wrap .hero-bg-slideshow .hero-bg {\n  background-attachment: inherit;\n}\n\n.oxyy-login-register .hero-wrap .hero-bg-slideshow.owl-carousel .owl-stage-outer,\n.oxyy-login-register .hero-wrap .hero-bg-slideshow.owl-carousel .owl-stage,\n.oxyy-login-register .hero-wrap .hero-bg-slideshow.owl-carousel .owl-item {\n  height: 100%;\n}\n\n@media (max-width: 991.98px) {\n  .oxyy-login-register .hero-wrap .hero-bg {\n    background-attachment: initial !important;\n    background-position: center center !important;\n  }\n}\n\n/* 4.2 Nav */\n.oxyy-login-register .nav .nav-item .nav-link {\n  color: #495057;\n}\n\n.oxyy-login-register .nav:not(.nav-pills) .nav-item .nav-link.active,\n.oxyy-login-register .nav:not(.nav-pills) .nav-item .nav-link:hover {\n  color: var(--bs-themecolor);\n}\n\n.oxyy-login-register .nav.nav-separator .nav-item .nav-link {\n  position: relative;\n}\n\n.oxyy-login-register .nav.nav-separator .nav-item+.nav-item .nav-link:after {\n  height: 14px;\n  width: 1px;\n  content: ' ';\n  background-color: rgba(0, 0, 0, 0.2);\n  display: block;\n  position: absolute;\n  top: 50%;\n  left: 0;\n  -webkit-transform: translateY(-7px);\n  transform: translateY(-7px);\n}\n\n.oxyy-login-register html[dir=\"rtl\"] .nav.nav-separator .nav-item+.nav-item .nav-link:after {\n  right: 0;\n  left: auto;\n}\n\n.oxyy-login-register .nav.nav-separator.nav-separator-light .nav-item+.nav-item .nav-link:after {\n  background-color: rgba(250, 250, 250, 0.2);\n}\n\n.oxyy-login-register .nav.nav-sm .nav-item .nav-link {\n  font-size: 14px;\n}\n\n.oxyy-login-register .nav-pills .nav-link:not(.active):hover {\n  color: var(--bs-themecolor);\n}\n\n.oxyy-login-register .nav-pills .nav-link.active,\n.oxyy-login-register .nav-pills.nav-light .nav-link.active,\n.oxyy-login-register .nav-pills .show>.nav-link {\n  color: #fff;\n}\n\n.oxyy-login-register .nav-pills .nav-link {\n  color: #7b8084;\n}\n\n\n.oxyy-login-register .nav-pills {\n  --bs-nav-pills-link-active-bg: var(--bs-themecolor);\n}\n\n.oxyy-login-register [data-bs-theme=\"dark\"] .nav .nav-item .nav-link:not(.active) {\n  color: #dee2e6;\n}\n\n.oxyy-login-register [data-bs-theme=\"dark\"] .nav:not(.nav-pills) .nav-item .nav-link.active,\n.oxyy-login-register [data-bs-theme=\"dark\"] .nav .nav-item .nav-link:not(.active):hover {\n  color: var(--bs-themecolor);\n}\n\n.oxyy-login-register [data-bs-theme=\"dark\"] .nav.nav-separator .nav-item+.nav-item .nav-link:after {\n  background-color: rgba(250, 250, 250, 0.2);\n}\n\n/*=== 4.3 Tabs ===*/\n.oxyy-login-register .nav-underline {\n  --bs-nav-underline-gap: 0rem;\n}\n\n.oxyy-login-register .nav-underline .nav-link {\n  padding-left: var(--bs-nav-link-padding-x);\n  padding-right: var(--bs-nav-link-padding-x);\n}\n\n.oxyy-login-register .nav-underline .nav-link:not(.active):hover {\n  border-bottom: 0px;\n  border-bottom-color: transparent;\n}\n\n.oxyy-login-register .nav-underline .nav-link.active {\n  font-weight: 500;\n}\n\n/* 4.4 Video Play button */\n.oxyy-login-register .btn-video-play {\n  width: 66px;\n  height: 66px;\n  line-height: 66px;\n  text-align: center;\n  display: inline-block;\n  font-size: 16px;\n  border-radius: 50%;\n  background: #fff;\n  -webkit-box-shadow: 0px 0px 50px -35px rgba(0, 0, 0, 0.4);\n  box-shadow: 0px 0px 50px -35px rgba(0, 0, 0, 0.4);\n  -webkit-transition: all 0.8s ease-in-out;\n  transition: all 0.8s ease-in-out;\n}\n\n.oxyy-login-register .btn-video-play:hover {\n  -webkit-box-shadow: 0px 0px 0px 8px rgba(250, 250, 250, 0.2);\n  box-shadow: 0px 0px 0px 8px rgba(250, 250, 250, 0.2);\n}\n\n/* =================================== */\n/*  5. Social Icons\n/* =================================== */\n.oxyy-login-register .social-icons {\n  margin: 0;\n  padding: 0;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n  list-style: none;\n}\n\n.oxyy-login-register .social-icons li {\n  margin: 0px 6px 4px;\n  padding: 0;\n  overflow: visible;\n}\n\n.oxyy-login-register .social-icons li a {\n  display: block;\n  height: 38px;\n  line-height: 38px;\n  width: 38px;\n  font-size: 18px;\n  text-align: center;\n  background-color: rgba(0, 0, 0, 0.6);\n  color: #fff;\n  text-decoration: none;\n  -webkit-transition: all 0.2s ease;\n  transition: all 0.2s ease;\n}\n\n.oxyy-login-register .social-icons li i {\n  line-height: inherit;\n}\n\n.oxyy-login-register .social-icons.social-icons-lg li a {\n  height: 45px;\n  line-height: 45px;\n  width: 45px;\n}\n\n.oxyy-login-register .social-icons li:hover a {\n  opacity: 0.8;\n}\n\n.oxyy-login-register .social-icons.social-icons-rounded li a {\n  border-radius: .25rem;\n}\n\n.oxyy-login-register .social-icons.social-icons-circle li a {\n  border-radius: 50%;\n}\n\n.oxyy-login-register .social-icons li.social-icons-twitter a {\n  background-color: #00ACEE;\n}\n\n.oxyy-login-register .social-icons li.social-icons-facebook a {\n  background-color: #1874eb;\n}\n\n.oxyy-login-register .social-icons li.social-icons-linkedin a {\n  background-color: #0E76A8;\n}\n\n.oxyy-login-register .social-icons li.social-icons-google a {\n  background-color: #DB4437;\n}\n\n.oxyy-login-register .social-icons li.social-icons-instagram a {\n  background-color: #3F729B;\n}\n\n.oxyy-login-register .social-icons li.social-icons-vk a {\n  background-color: #2B587A;\n}\n\n.oxyy-login-register .social-icons li.social-icons-yahoo a {\n  background-color: #720E9E;\n}\n\n.oxyy-login-register .social-icons li.social-icons-apple a {\n  background-color: #000;\n}\n\n.oxyy-login-register .social-icons li.social-icons-windows a {\n  background-color: #0090f4;\n}\n\n.oxyy-login-register .social-icons li.social-icons-amazon a {\n  background-color: #f79400;\n}\n\n.oxyy-login-register .btn-facebook {\n  background-color: #1874eb;\n  color: #fff !important;\n}\n\n.oxyy-login-register .btn-facebook:hover {\n  background-color: #1266d2;\n}\n\n.oxyy-login-register .btn-outline-facebook {\n  border-color: #1874eb;\n  color: #1874eb;\n}\n\n.oxyy-login-register .btn-outline-facebook:hover {\n  background-color: #1874eb;\n  color: #fff;\n}\n\n.oxyy-login-register .btn-twitter {\n  background-color: #00ACEE;\n  color: #fff !important;\n}\n\n.oxyy-login-register .btn-twitter:hover {\n  background-color: #0096cf;\n}\n\n.oxyy-login-register .btn-outline-twitter {\n  border-color: #00ACEE;\n  color: #00ACEE;\n}\n\n.oxyy-login-register .btn-outline-twitter:hover {\n  background-color: #00ACEE;\n  color: #fff;\n}\n\n.oxyy-login-register .btn-google {\n  background-color: #DB4437;\n  color: #fff !important;\n}\n\n.oxyy-login-register .btn-google:hover {\n  background-color: #ce3325;\n}\n\n.oxyy-login-register .btn-outline-google {\n  border-color: #DB4437;\n  color: #DB4437;\n}\n\n.oxyy-login-register .btn-outline-google:hover {\n  background-color: #DB4437;\n  color: #fff;\n}\n\n.oxyy-login-register .btn-linkedin {\n  background-color: #0E76A8;\n  color: #fff !important;\n}\n\n.oxyy-login-register .btn-linkedin:hover {\n  background-color: #0c628c;\n}\n\n.oxyy-login-register .btn-outline-linkedin {\n  border-color: #0E76A8;\n  color: #0E76A8;\n}\n\n.oxyy-login-register .btn-outline-linkedin:hover {\n  background-color: #0E76A8;\n  color: #fff;\n}\n\n.oxyy-login-register .btn-instagram {\n  background-color: #3F729B;\n  color: #fff !important;\n}\n\n.oxyy-login-register .btn-instagram:hover {\n  background-color: #366285;\n}\n\n.oxyy-login-register .btn-outline-instagram {\n  border-color: #3F729B;\n  color: #3F729B;\n}\n\n.oxyy-login-register .btn-outline-instagram:hover {\n  background-color: #3F729B;\n  color: #fff;\n}\n\n.oxyy-login-register .btn-vk {\n  background-color: #2B587A;\n  color: #fff !important;\n}\n\n.oxyy-login-register .btn-vk:hover {\n  background-color: #234863;\n}\n\n.oxyy-login-register .btn-outline-vk {\n  border-color: #2B587A;\n  color: #2B587A;\n}\n\n.oxyy-login-register .btn-outline-vk:hover {\n  background-color: #2B587A;\n  color: #fff;\n}\n\n.oxyy-login-register .btn-yahoo {\n  background-color: #720E9E;\n  color: #fff !important;\n}\n\n.oxyy-login-register .btn-yahoo:hover {\n  background-color: #5e0c82;\n}\n\n.oxyy-login-register .btn-outline-yahoo {\n  border-color: #720E9E;\n  color: #720E9E;\n}\n\n.oxyy-login-register .btn-outline-yahoo:hover {\n  background-color: #720E9E;\n  color: #fff;\n}\n\n.oxyy-login-register .btn-apple {\n  background-color: #000;\n  color: #fff !important;\n}\n\n.oxyy-login-register .btn-apple:hover {\n  background-color: black;\n}\n\n.oxyy-login-register .btn-outline-apple {\n  border-color: #000;\n  color: #000;\n}\n\n.oxyy-login-register .btn-outline-apple:hover {\n  background-color: #000;\n  color: #fff;\n}\n\n.oxyy-login-register .btn-windows {\n  background-color: #0090f4;\n  color: #fff !important;\n}\n\n.oxyy-login-register .btn-windows:hover {\n  background-color: #007ed5;\n}\n\n.oxyy-login-register .btn-outline-windows {\n  border-color: #0090f4;\n  color: #0090f4;\n}\n\n.oxyy-login-register .btn-outline-windows:hover {\n  background-color: #0090f4;\n  color: #fff;\n}\n\n.oxyy-login-register .btn-amazon {\n  background-color: #f79400;\n  color: #fff !important;\n}\n\n.oxyy-login-register .btn-amazon:hover {\n  background-color: #d88200;\n}\n\n.oxyy-login-register .btn-outline-amazon {\n  border-color: #f79400;\n  color: #f79400;\n}\n\n.oxyy-login-register .btn-outline-amazon:hover {\n  background-color: #f79400;\n  color: #fff;\n}\n\n/* =================================== */\n/*  6. Extras\n/* =================================== */\n/* 6.1 Form */\n.oxyy-login-register .form-control {\n  border-color: #d1eaff;\n  box-shadow: inset 0 0;\n  background-color: #e8f1fb;\n  border-radius: 4px !important;\n}\n\n.oxyy-login-register .form-check-input:not(:checked) {\n  border-color: #dae1e3;\n}\n\n.oxyy-login-register .form-control.bg-light {\n  background-color: #f5f5f6 !important;\n}\n\n.oxyy-login-register .form-control.border-light {\n  border-color: #f5f5f6 !important;\n}\n\n.oxyy-login-register .form-control:not(.form-control-sm) {\n  padding: 20px !important;\n  height: inherit;\n}\n\n.oxyy-login-register .form-control-sm {\n  font-size: 14px;\n}\n\n.oxyy-login-register .icon-group {\n  position: relative;\n}\n\n.oxyy-login-register .icon-group .form-control {\n  padding-left: 44px;\n}\n\n.oxyy-login-register .icon-group .icon-inside {\n  position: absolute;\n  width: 50px;\n  height: 54px;\n  left: 0;\n  top: 0;\n  pointer-events: none;\n  font-size: 18px;\n  font-size: 1.125rem;\n  color: #c4c3c3;\n  z-index: 3;\n  display: flex;\n  -ms-flex-align: center !important;\n  align-items: center !important;\n  -ms-flex-pack: center !important;\n  justify-content: center !important;\n}\n\n.oxyy-login-register .icon-group.icon-group-end .form-control {\n  padding-right: 44px;\n  padding-left: 0.96rem;\n}\n\n.oxyy-login-register .icon-group.icon-group-end .icon-inside {\n  left: auto;\n  right: 0;\n}\n\n.oxyy-login-register .form-control-sm+.icon-inside {\n  font-size: 0.875rem !important;\n  font-size: 14px;\n  top: calc(50% - 13px);\n}\n\n.oxyy-login-register select.form-control:not([size]):not([multiple]):not(.form-control-sm) {\n  height: auto;\n  padding-top: .700rem;\n  padding-bottom: .700rem;\n}\n\n.oxyy-login-register .form-control:focus {\n  -webkit-box-shadow: 0 0 5px rgba(128, 189, 255, 0.5);\n  box-shadow: 0 0 5px rgba(128, 189, 255, 0.5);\n  border-color: #80bdff !important;\n}\n\n.oxyy-login-register .form-control:focus[readonly] {\n  box-shadow: none;\n}\n\n.oxyy-login-register .input-group-text {\n  border-color: #dae1e3;\n  background-color: #f1f5f6;\n  color: #656565;\n}\n\n.oxyy-login-register .form-control::-webkit-input-placeholder {\n  color: #b1b4b6;\n}\n\n.oxyy-login-register .form-control:-moz-placeholder {\n  /* FF 4-18 */\n  color: #b1b4b6;\n}\n\n.oxyy-login-register .form-control::-moz-placeholder {\n  /* FF 19+ */\n  color: #b1b4b6;\n}\n\n.oxyy-login-register .form-control:-ms-input-placeholder,\n.oxyy-login-register .form-control::-ms-input-placeholder {\n  /* IE 10+ */\n  color: #b1b4b6;\n}\n\n/* 6.2 Form Dark */\n.oxyy-login-register .form-dark .form-control {\n  border-color: #232a31;\n  background: #232a31;\n  color: #fff;\n}\n\n.oxyy-login-register .form-dark .form-control:focus {\n  border-color: #80bdff !important;\n}\n\n.oxyy-login-register .form-dark .form-control::-webkit-input-placeholder {\n  color: #777b7f;\n}\n\n.oxyy-login-register .form-dark .form-control:-moz-placeholder {\n  /* FF 4-18 */\n  color: #777b7f;\n}\n\n.oxyy-login-register .form-dark .form-control::-moz-placeholder {\n  /* FF 19+ */\n  color: #777b7f;\n}\n\n.oxyy-login-register .form-dark .form-control:-ms-input-placeholder,\n.oxyy-login-register .form-dark .form-control::-ms-input-placeholder {\n  /* IE 10+ */\n  color: #777b7f;\n}\n\n.oxyy-login-register .form-dark .icon-group .icon-inside {\n  color: #777b7f;\n}\n\n.oxyy-login-register .form-dark .form-check-input:not(:checked) {\n  background-color: #232a31;\n  border-color: #232a31;\n}\n\n/* 6.3 Form Border (Input with only bottom border)  */\n.oxyy-login-register .form-border .form-control {\n  background-color: transparent;\n  border: none;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.12);\n  border-radius: 0px;\n  padding-left: 0px !important;\n  color: black;\n}\n\n.oxyy-login-register .form-border .form-control::-webkit-input-placeholder {\n  color: rgba(0, 0, 0, 0.4);\n}\n\n.oxyy-login-register .form-border .form-control:-moz-placeholder {\n  /* FF 4-18 */\n  color: rgba(0, 0, 0, 0.4);\n}\n\n.oxyy-login-register .form-border .form-control::-moz-placeholder {\n  /* FF 19+ */\n  color: rgba(0, 0, 0, 0.4);\n}\n\n.oxyy-login-register .form-border .form-control:-ms-input-placeholder,\n.oxyy-login-register .form-border .form-control::-ms-input-placeholder {\n  /* IE 10+ */\n  color: rgba(0, 0, 0, 0.4);\n}\n\n.oxyy-login-register .form-border .form-control:focus {\n  box-shadow: none;\n  -webkit-box-shadow: none;\n  border-bottom-color: rgba(0, 0, 0, 0.7);\n}\n\n.oxyy-login-register .form-border .form-control:focus.border-dark {\n  border-color: var(--bs-themecolor) !important;\n}\n\n.oxyy-login-register .form-border .form-control:not(output):-moz-ui-invalid:not(:focus),\n.oxyy-login-register .form-border .form-control:not(output):-moz-ui-invalid:-moz-focusring:not(:focus) {\n  border-bottom-color: #e10203;\n  box-shadow: none;\n  -webkit-box-shadow: none;\n}\n\n.oxyy-login-register .form-border .form-control:not(output):-moz-ui-invalid:not(:focus).border-dark,\n.oxyy-login-register .form-border .form-control:not(output):-moz-ui-invalid:-moz-focusring:not(:focus).border-dark {\n  border-color: #e10203 !important;\n}\n\n.oxyy-login-register .form-border select option {\n  color: #666;\n}\n\n.oxyy-login-register .form-border .icon-group .form-control {\n  padding-left: 30px !important;\n}\n\n.oxyy-login-register .form-border .icon-group .icon-inside {\n  color: rgba(0, 0, 0, 0.25);\n  width: 30px;\n  height: 52px;\n  display: flex;\n  -ms-flex-align: center !important;\n  align-items: center !important;\n  -ms-flex-pack: start !important;\n  justify-content: flex-start !important;\n}\n\n.oxyy-login-register .form-border .icon-group.icon-group-end .form-control {\n  padding-right: 30px !important;\n  padding-left: 0 !important;\n}\n\n.oxyy-login-register .form-border .icon-group.icon-group-end .icon-inside {\n  left: auto;\n  right: 0;\n  -ms-flex-pack: end !important;\n  justify-content: flex-end !important;\n}\n\n/* 6.4 Form Border Light (Input with only bottom border)  */\n.oxyy-login-register .form-border-light .form-control {\n  border-bottom: 1px solid rgba(250, 250, 250, 0.3);\n  color: #fafafa;\n}\n\n.oxyy-login-register .form-border-light .form-control::-webkit-input-placeholder {\n  color: rgba(250, 250, 250, 0.7);\n}\n\n.oxyy-login-register .form-border-light .form-control:-moz-placeholder {\n  /* FF 4-18 */\n  color: rgba(250, 250, 250, 0.7);\n}\n\n.oxyy-login-register .form-border-light .form-control::-moz-placeholder {\n  /* FF 19+ */\n  color: rgba(250, 250, 250, 0.7);\n}\n\n.oxyy-login-register .form-border-light .form-control:-ms-input-placeholder,\n.oxyy-login-register .form-border-light .form-control::-ms-input-placeholder {\n  /* IE 10+ */\n  color: rgba(250, 250, 250, 0.7);\n}\n\n.oxyy-login-register .form-border-light .form-control:focus {\n  border-bottom-color: rgba(250, 250, 250, 0.8);\n}\n\n.oxyy-login-register .form-border-light .form-control:focus.border-light {\n  border-color: var(--bs-themecolor) !important;\n}\n\n.oxyy-login-register .form-border-light .icon-group .icon-inside {\n  color: #777b7f;\n}\n\n.oxyy-login-register .form-border-light select option {\n  color: #333;\n}\n\n/* 6.5 Vertical Multilple input group */\n.oxyy-login-register .vertical-input-group .input-group:first-child {\n  padding-bottom: 0;\n}\n\n.oxyy-login-register .vertical-input-group .input-group:first-child * {\n  border-bottom-left-radius: 0;\n  border-bottom-right-radius: 0;\n}\n\n.oxyy-login-register .vertical-input-group .input-group:last-child {\n  padding-top: 0;\n}\n\n.oxyy-login-register .vertical-input-group .input-group:last-child * {\n  border-top-left-radius: 0;\n  border-top-right-radius: 0;\n}\n\n.oxyy-login-register .vertical-input-group .input-group:not(:last-child):not(:first-child) {\n  padding-top: 0;\n  padding-bottom: 0;\n}\n\n.oxyy-login-register .vertical-input-group .input-group:not(:last-child):not(:first-child) * {\n  border-radius: 0;\n}\n\n.oxyy-login-register .vertical-input-group .input-group:not(:first-child) * {\n  border-top: 0;\n}\n\n/* 6.6 Other Bootstrap Specific */\n.oxyy-login-register .btn {\n  padding: 0.8rem 2.6rem;\n  font-weight: 500;\n  -webkit-transition: all 0.5s ease;\n  transition: all 0.5s ease;\n}\n\n.oxyy-login-register .btn-sm {\n  padding: 0.5rem 1rem;\n}\n\n.oxyy-login-register .btn:not(.btn-link) {\n  -webkit-box-shadow: 0px 5px 15px rgba(0, 0, 0, 0.15);\n  box-shadow: 0px 5px 15px rgba(0, 0, 0, 0.15);\n}\n\n.oxyy-login-register .btn:not(.btn-link):hover {\n  -webkit-box-shadow: 0px 5px 15px rgba(0, 0, 0, 0.3);\n  box-shadow: 0px 5px 15px rgba(0, 0, 0, 0.3);\n  -webkit-transition: all 0.5s ease;\n  transition: all 0.5s ease;\n}\n\n.oxyy-login-register .input-group-append .btn,\n.oxyy-login-register .input-group-prepend .btn {\n  -webkit-box-shadow: none;\n  box-shadow: none;\n  padding-left: 0.75rem;\n  padding-right: 0.75rem;\n}\n\n.oxyy-login-register .input-group-append .btn:hover,\n.oxyy-login-register .input-group-prepend .btn:hover {\n  -webkit-box-shadow: none;\n  box-shadow: none;\n}\n\n@media (max-width: 575.98px) {\n  .oxyy-login-register .btn:not(.btn-sm) {\n    padding: .810rem 2rem;\n  }\n\n  .oxyy-login-register .input-group>.input-group-append>.btn,\n  .oxyy-login-register .input-group>.input-group-prepend>.btn {\n    padding: 0 0.75rem;\n  }\n}\n\n.oxyy-login-register .btn-primary {\n  background-color: #1170e6;\n  font-size: 16px;\n}\n\n.oxyy-login-register .btn-outline-primary {\n  --bs-btn-color: var(--bs-themecolor);\n  --bs-btn-border-color: var(--bs-themecolor);\n  --bs-btn-hover-bg: var(--bs-themecolor);\n  --bs-btn-hover-color: var(--bs-white);\n  --bs-btn-hover-border-color: var(--bs-themecolor);\n  --bs-btn-active-color: var(--bs-btn-hover-color);\n  --bs-btn-active-bg: var(--bs-themehovercolor);\n  --bs-btn-active-border-color: var(--bs-themehovercolor);\n}\n\n.oxyy-login-register .progress,\n.oxyy-login-register .progress-stacked {\n  --bs-progress-bar-bg: var(--bs-themecolor);\n}\n\n.oxyy-login-register .pagination {\n  --bs-pagination-active-bg: var(--bs-themecolor);\n  --bs-pagination-active-border-color: var(--bs-themecolor);\n}\n\n/* styles-switcher */\n#styles-switcher {\n  background: #fff;\n  width: 202px;\n  position: fixed;\n  top: 35%;\n  z-index: 1051;\n  padding: 20px;\n  left: -202px;\n}\n\n#styles-switcher ul {\n  padding: 0;\n}\n\n#styles-switcher ul li {\n  list-style-type: none;\n  width: 24px;\n  height: 24px;\n  line-height: 24px;\n  margin: 4px 2px;\n  border-radius: 50%;\n  display: inline-block;\n  cursor: pointer;\n  text-align: center;\n  color: #fff;\n  transition: all .2s ease-in-out;\n}\n\n#styles-switcher ul li.blue {\n  background: #007bff;\n}\n\n#styles-switcher ul li.brown {\n  background: #795548;\n}\n\n#styles-switcher ul li.purple {\n  background: #6f42c1;\n}\n\n#styles-switcher ul li.indigo {\n  background: #6610f2;\n}\n\n#styles-switcher ul li.red {\n  background: #dc3545;\n}\n\n#styles-switcher ul li.orange {\n  background: #fd7e14;\n}\n\n#styles-switcher ul li.yellow {\n  background: #ffc107;\n}\n\n#styles-switcher ul li.green {\n  background: #28a745;\n}\n\n#styles-switcher ul li.teal {\n  background: #20c997;\n}\n\n#styles-switcher ul li.pink {\n  background: #e83e8c;\n}\n\n#styles-switcher ul li.cyan {\n  background: #17a2b8;\n}\n\n#styles-switcher ul li.active {\n  transform: scale(0.7);\n  cursor: default;\n}\n\n#styles-switcher .switcher-toggle {\n  position: absolute;\n  background: #555;\n  color: #fff;\n  font-size: 1.25rem;\n  border-radius: 0px 4px 4px 0;\n  right: -40px;\n  top: 0;\n  width: 40px;\n  height: 40px;\n  padding: 0;\n}\n\n#styles-switcher .switcher-toggle:focus {\n  box-shadow: none;\n}\n\n#styles-switcher #reset-color {\n  background: #007bff;\n}\n\ninput:-internal-autofill-selected {\n  background-color: transparent;\n}\n\n#styles-switcher.right {\n  left: auto;\n  right: -202px;\n}\n\n#styles-switcher.right .switcher-toggle {\n  right: auto;\n  left: -40px;\n  border-radius: 4px 0px 0px 4px;\n}\n\n.hero-bg .hero-bg-scroll {\n  background-image: url(\"/src/assets/images/bg.png\") !important;\n}\n\n.btn:first-child:active {\n  background-color: #0257d5;\n  color: #fff;\n}\n\n#logo {\n  background-image: url('/src/assets/images/HelixLogo.png') !important;\n}\n\n.fn {\n  font-size: 14px;\n  color: #004397;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
